var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form,
      labelAlign: "right",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("客户名称")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("客户名称"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    on: {
      change: _vm.customerIdChange
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customersList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("适用架构")
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      width: "100%"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "40%"
    },
    attrs: {
      placeholder: _vm.structureTypePlaceholder,
      allowClear: "",
      disabled: !_vm.form.customerId
    },
    on: {
      change: _vm.structureTypeChange
    },
    model: {
      value: _vm.form.structureType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "structureType", $$v);
      },
      expression: "form.structureType"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "ALL"
    }
  }, [_vm._v(_vm._s(_vm.$t("全部")))]), _c("a-select-option", {
    attrs: {
      value: "DIVISION"
    }
  }, [_vm._v(_vm._s(_vm.$t("部门")))]), _c("a-select-option", {
    attrs: {
      value: "PERSONNEL"
    }
  }, [_vm._v(_vm._s(_vm.$t("人员")))])], 1), _c("a-tree-select", {
    staticClass: "list-message-tree",
    staticStyle: {
      width: "60%",
      "flex-grow": "0",
      "margin-left": "10px"
    },
    attrs: {
      showSearch: "",
      multiple: "",
      "dropdown-style": {
        marginLeft: "10px",
        maxHeight: "400px",
        maxWidth: "256px",
        overflow: "auto"
      },
      maxTagCount: 1,
      treeDefaultExpandAll: true,
      disabled: !_vm.form.customerId || !_vm.form.structureType || _vm.form.structureType === "ALL",
      treeNodeFilterProp: "title",
      "tree-data": _vm.form.structureType === "DIVISION" ? _vm.structureList : _vm.structureListTree
    },
    model: {
      value: _vm.form.associationId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "associationId", $$v);
      },
      expression: "form.associationId"
    }
  })], 1)])], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("备注")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("备注"),
      allowClear: ""
    },
    model: {
      value: _vm.form.remark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "remark", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.remark"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("消息类别")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("消息类别"),
      allowClear: ""
    },
    on: {
      change: _vm.flowTypeIdChange
    },
    model: {
      value: _vm.form.messageCategory,
      callback: function ($$v) {
        _vm.$set(_vm.form, "messageCategory", $$v);
      },
      expression: "form.messageCategory"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "AUDIT_FLOW"
    }
  }, [_vm._v(_vm._s(_vm.$t("审核流相关")))]), _c("a-select-option", {
    attrs: {
      value: "INSURE"
    }
  }, [_vm._v(_vm._s(_vm.$t("投保相关")))]), _c("a-select-option", {
    attrs: {
      value: "TASK_LIST"
    }
  }, [_vm._v(_vm._s(_vm.$t("任务列表相关")))]), _c("a-select-option", {
    attrs: {
      value: "SURRENDER_INSURANCE"
    }
  }, [_vm._v(_vm._s(_vm.$t("退保相关")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("推送场景")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.pushScenarioPlaceholder,
      allowClear: "",
      disabled: !_vm.form.messageCategory
    },
    model: {
      value: _vm.form.pushScenario,
      callback: function ($$v) {
        _vm.$set(_vm.form, "pushScenario", $$v);
      },
      expression: "form.pushScenario"
    }
  }, _vm._l(_vm.pushScenarioList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.pushScenario
      }
    }, [_vm._v(_vm._s(_vm.$t(item.pushScenarioName)))]);
  }), 1)], 1)], 1)], 1), _c("div", {
    staticClass: "marginT10"
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t("重置")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.newMessage
    }
  }, [_vm._v(_vm._s(_vm.$t("新增")))])], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.dataSource,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: _vm.checkedItem(text)
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun(record);
            }
          }
        })];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.editMessage(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]), _c("a-button", {
          attrs: {
            type: "primary",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.copyMessage(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("复制")))])];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };